<template>
  <div class="ifr" v-loading="loading">
		<div class="payinfoTitle">{{$vi18n('$i18n# 支付信息 #i18n$')}}</div>
		<iframe
			v-if="!need"
			:src="url"
			frameborder="0"
			width="1010px"
			height="800px"
			style="margin: 20px 30px 0 30px"
		></iframe>
		<div class="verification" v-if="need">
			<div class="title">{{$vi18n('$i18n# 验证身份 #i18n$')}}</div>
			<div class="checkCode">
				<div class="phone">
					<div class="title">{{$vi18n('$i18n# 邮箱 #i18n$')}}</div>
					<el-input :disabled="true" :value="email"></el-input>
				</div>
				<div class="_code">
					<div class="title">{{$vi18n('$i18n# 验证码 #i18n$')}}</div>
					<el-input v-model="checkCodeV">
						<template slot="append">
							<el-button :disabled="!checkLock" @click="getCheckCode" type="primary">{{
								checkTimer
							}}</el-button>
						</template>
					</el-input>
				</div>
				<el-button @click="checkCodeHandler" class="_btn" :disabled="loading" type="primary" size="medium">OK</el-button>
			</div>
			<br>
		</div>
		<NoviciateMask v-if="isNoviciateDeveloper"></NoviciateMask>
	</div>
</template>

<script>
import { getIframeUrl, getAccount, getCode, checkCode } from '@/api/account.js';
import { $vi18n } from '@/utils/i18n.js';
import { mapState } from 'vuex';
import NoviciateMask from '@/components/NoviciateMask'
export default {
	components: {
    NoviciateMask
  },
	data() {
		return {
			url: '',
			showPage: false,
			checkTimer: '',
			checkLock: true,
			checkCodeV: '',
			email: '',
			need: true,
			loading: true
		};
	},
	computed: {
    ...mapState(['developerInfo']),
    isNoviciateDeveloper() {
      return this.developerInfo.dev_state === 2
    },
  },
	created() {
		this.getAccountHandler();
    this.initDate();
	},
	methods: {
		async getUrl() {
			try {
				const res = await getIframeUrl({
					uin: sessionStorage.getItem('uin')
				});
				const data = res.data || {};
				this.url = decodeURIComponent(data.setup_process_url);
			} catch (error) {
				console.log(error);
			}
		},
		async getAccountHandler() {
			try {
				this.loading = true;
				const res = await getAccount({
					uin: sessionStorage.getItem('uin')
				});
				const data = res.data || {}
				this.email = data.email;
				this.loading = false;
			} catch (error) {
				console.log(error);
				this.loading = false;
			}
		},
		async getCheckCode() {
			if (this.checkLock) {
				this.checkLock = false;
				try {
					const res = await getCode({
						uin: sessionStorage.getItem('uin'),
						email: this.email,
					});
					this.$message({
						message: $vi18n('$i18n# 验证码已发送至您的邮箱！ #i18n$'),
						type: 'success',
					});
					let time = 60;
					this.checkTimer = time + 's';
					const Time = setInterval(() => {
						if (time === 0) {
							this.checkTimer = $vi18n('$i18n# 获取验证码 #i18n$');
							clearInterval(Time);
							this.checkLock = true;
						} else {
							time = time - 1;
							this.checkTimer = time + 's';
						}
					}, 1000);
				} catch (error) {
					this.checkLock = true;
				}
			} else {
				this.$message({
					message: $vi18n('$i18n# 你的操作太频繁！ #i18n$'),
					type: 'warning',
				});
			}
		},
		async checkCodeHandler() {
			try {
				this.loading = true;
				await checkCode({
					uin: sessionStorage.getItem('uin'),
					sms_code: this.checkCodeV,
					sub_req: 'get_tipalti_frame',
				});
				this.checkCodeV = '';
				this.need = false;
				this.getUrl()
			} catch (error) {
				console.log(error);
			} finally {
				this.loading = false;
			}
		},
		initDate() {
			// this.getUrl();
			this.checkTimer = $vi18n('$i18n# 获取验证码 #i18n$');
		}
	}
};
</script>

<style lang="scss" scoped>
.ifr {
  position: relative;
  .noviciate-mask {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100% !important;
    background: rgba(255, 255, 255, 0.92);
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
    // justify-content: center;
    .icon {
      width: 150px;
      margin-top: 20px;
    }
    .head {
      font-size: 30px;
      color: #595959;
      margin-top: 10px;
    }
    .desc {
      font-size: 18px;
      color: #6e6969;
      margin-top: 10px;
    }
    .btn {
      margin-top: 20px;
    }
  }
}
.content-wrapper {
	padding: 0;
}
.code {
  cursor: pointer;
  width: 110px;
  color: #fd9b21 !important;
}

.uncode {
  width: 110px;
}
.payinfoTitle {
  font-size: 22px;
  height: 60px;
  line-height: 60px;
  padding: 0 35px 0 35px;
  border-bottom: 1px solid #d9d9d9;
}

.title {
  font-size: 20px;
  font-weight: bold;
  margin-left: 240px;
}

.verification {
  margin-left: 194px;
  margin-top: 50px;
}

.checkCode {
  margin-top: 50px;
  .phone {
    display: flex;

    .title {
      font-size: 14px;
      //   color: rgba(38, 38, 38, 1);
      line-height: 36px;
      margin-right: 40px;
      margin-left: 30px;
      width: 100px;
    }

    .el-input {
      width: 400px;
      //   height: 36px;
    }
  }

  ._code {
    margin-top: 24px;
    display: flex;

    .title {
      font-size: 14px;
      line-height: 36px;
      margin-right: 40px;
      margin-left: 30px;
      width: 100px;
    }

    .el-input {
      width: 400px;
      height: 36px;
    }
  }

  ._btn {
    margin-top: 30px;
    margin-left: 230px;
  }
}

</style>
